import React, { View } from "react-native";
import {
    Button,
    DateTimePickerInput,
    Form as FormType,
    InputControl,
    Picker,
    RequiredText,
    StyleFunction,
    useThemedStyle,
} from "@venuepos/react-common";
import { useTranslation } from "locales";
import { DSFinVKExportForm } from "./validation";
import { dateToDateTime } from "lib";
import { GQFiskalyClientsQuery } from "graphql-sdk";

export function Form({
    form,
    onSubmit,
    submitButton,
    requestRunning,
    clients,
}: {
    form: FormType<DSFinVKExportForm>;
    onSubmit: () => void;
    submitButton: [string, string];
    requestRunning: boolean;
    clients?: GQFiskalyClientsQuery;
}) {
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);
    const [{ values, errors }, { setValue, handleSubmit }] = form;

    if (!values) {
        return null;
    }

    return (
        <>
            <View style={styles.row}>
                <InputControl style={styles.column} error={errors.from}>
                    <DateTimePickerInput
                        value={dateToDateTime(values.from)}
                        label={t("common.from", "From")}
                        onChangeDate={newDate => setValue("from", newDate)}
                        dateTimeType="dateTime"
                        required
                    />
                </InputControl>
                <InputControl style={styles.column} error={errors.to}>
                    <DateTimePickerInput
                        value={dateToDateTime(values.to)}
                        label={t("common.to", "To")}
                        onChangeDate={newDate => setValue("to", newDate)}
                        dateTimeType="dateTime"
                        required
                    />
                </InputControl>
                <InputControl style={styles.column} error={errors.clientId}>
                    <Picker
                        selectedValue={values.clientId}
                        label={t(
                            "backoffice.integration.fiskaly.client",
                            "Client"
                        )}
                        onValueChange={newValue =>
                            setValue("clientId", newValue)
                        }
                        disabled={clients?.fiskalyClients?.data.length === 0}
                    >
                        <Picker.Item
                            value=""
                            key="__select__"
                            label={t(
                                "backoffice.integration.fiskaly.dsfinvk_export.select_client",
                                "Select a client"
                            )}
                        />
                        {clients?.fiskalyClients?.data.map(itr => (
                            <Picker.Item
                                value={itr.id}
                                label={`${itr.cashRegister.name}`}
                                key={itr.id}
                            />
                        ))}
                    </Picker>
                </InputControl>
            </View>
            <Button
                onPress={handleSubmit(onSubmit)}
                disabled={clients?.fiskalyClients?.data.length === 0}
                loading={requestRunning}
            >
                {t(submitButton[0], submitButton[1])}
            </Button>
            <RequiredText />
        </>
    );
}

const styleFunc: StyleFunction = theme => ({
    column: { flex: 1 },
    row: { ...theme.styles.row, gap: theme.spacingScale },
});
